import styled from 'styled-components';


const DropdownMenu = styled.ul`
  list-style: none;
  padding: 8px;
  margin: 0;
  position: absolute;
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  min-width: 160px;
  width: max-content;
  max-height: 0;
  overflow: hidden;
  opacity: 0;
  visibility: hidden;
  transition: max-height 0.3s ease, opacity 0.3s ease, visibility 0.3s ease;
  z-index: 1000;

  .nav-item.dropdown:hover & {
    max-height: 500px;
    opacity: 1;
    visibility: visible;
  }

  li {
    margin: 0;
    
    a {
      display: block;
      padding: 8px 16px;
      color: #333;
      text-decoration: none;
      white-space: nowrap;
      border-radius: 4px;

      &:hover {
        background-color: #f0f0f0;
        text-decoration: none;
      }
    }

    hr {
      margin: 8px 0;
      border: none;
      border-top: 1px solid #ddd;
    }
  }
`;

export { DropdownMenu };